import styled from 'styled-components';
import theme from 'v3/theme';

export const Tabs = styled.div`
  border-bottom: 1px solid ${theme.colors.grayish_blue};
`;

export const Tab = styled.button`
  position: relative;
  border-radius: 5px 5px 0 0;
  font-size: 14px;
  min-width: 160px;
  padding: 10px 0;
  cursor: pointer;
  border: 1px solid ${theme.colors.grayish_blue};
  border-bottom: 0;
  transition: 'background-color 0.3s, font-weight 0.3s';
  margin: 0 8px 0 0;
  background: #ebebeb;

  ${(props) =>
    props.active &&
    `
    z-index: 1;
    background: ${theme.colors.white};
    font-weight: 600;
  `}

  ${(props) =>
    props.error &&
    `
    border-color: ${theme.colors.danger};
  `}
`;
